// src/pages/About.jsx
import React from "react";
import "./About.css";

import bertImg from "../assets/bert.png";
import hudsonImg from "../assets/hudson.jpeg";
import drMorrowImg from "../assets/drmorrow.png";

const team = [
  { id: "bert", name: "Albert Cheng", role: "Co-Founder · CEO", photo: bertImg },
  { id: "hudson", name: "Hudson Morrow", role: "Co-Founder · COO", photo: hudsonImg },
  { id: "drmorrow", name: "Dr. Jason Morrow", role: "Senior Advisor", photo: drMorrowImg },
];

export default function About() {
  return (
    <main className="about-page">
      <div className="about-shift">
        <div className="about-lines" aria-hidden="true">
          <span className="about-line v v1" />
          <span className="about-line v v2" />
        </div>

        <section className="about-hero">
          <div className="about-shell">
            <div className="about-hero-copy">
              <h1 className="about-title">
                Insurance denials should be{" "}
                <span className="about-title-accent">a solved problem</span>.
              </h1>

              <p className="about-subtitle">
                PanelZero exists to end the billing rework tax on US healthcare. Every year, hospitals and independent
                practices write off billions of dollars in legitimate claims because no one had time to write the appeal.
                We think the right response to a denial is not a spreadsheet — it&apos;s a system.
              </p>

              <div className="about-mission">
                <h2 className="about-section-kicker">Our mission</h2>
                <p className="about-mission-text">
                  Turn every denial into a drafted, evidence-backed appeal — automatically — so clinicians stay in
                  clinic, billers stay out of fax machines, and patients stop getting bills they don&apos;t owe.
                </p>
              </div>

              <div className="about-principles">
                <div className="principle">
                  <div className="principle-title">Clinically grounded</div>
                  <p className="principle-text">
                    Every appeal is tied to the chart. We cite CPT codes, LCDs, op notes, imaging — not vibes.
                  </p>
                </div>

                <div className="principle">
                  <div className="principle-title">EHR-native</div>
                  <p className="principle-text">
                    We speak FHIR, HL7 v2, and X12 out of the box. Live in Epic, Oracle Health, athenahealth, eClinicalWorks and every major EHR without rip-and-replace.
                  </p>
                </div>

                <div className="principle">
                  <div className="principle-title">Human-in-the-loop</div>
                  <p className="principle-text">
                    Drafts wait for review by default. Once a customer trusts a denial category, flip it to fully auto.
                    You stay in control — we do the typing.
                  </p>
                </div>
              </div>

              <div className="about-story">
                <h2 className="about-story-title">Why we built it</h2>
                <p>
                  Revenue cycle teams are heroic and under-resourced — whether that&apos;s a 30-person billing department
                  in a hospital system or a single office manager at an independent practice. Each denial requires
                  payer-specific phrasing, chart hunting, and fax chasing. The work is high-skill, low-leverage, and
                  impossible to scale by adding headcount.
                </p>
                <p>
                  PanelZero gives every biller a tireless expert partner — one that reads the denial, pulls the evidence,
                  writes the appeal, and tracks the clock. The biller becomes an editor. Your organization recovers the
                  revenue it earned.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="about-team">
          <div className="about-shell">
            <div className="about-team-header">
              <h2 className="about-team-title">Meet the team</h2>
              <div className="about-team-underline" />
              <p className="about-team-sub">
                A small team with deep experience in healthcare workflows, machine learning, and payer operations.
              </p>
            </div>

            <div className="about-team-grid">
              {team.map((m) => (
                <article className="team-card" key={m.id}>
                  <div className="team-photo-wrap">
                    <img className="team-photo" src={m.photo} alt={m.name} />
                  </div>
                  <div className="team-meta">
                    <div className="team-name">{m.name}</div>
                    <div className="team-role">{m.role}</div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
